import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

export interface IFrameInfo {
    left: number,
    top: number,
    width: number,
    height: number,
    flipH: number,
    flipV: number,
    rotate: number,
    srcRect?: any;
}

export function getValueWithDefault2(operation, style, defaultValue) {
    if (operation !== undefined) return operation;
    if (style !== undefined) return style;
    return defaultValue;
}

function getValueWithDefault1(style, defaultValue) {
    if (style !== undefined) return style;
    return defaultValue;
}

/**
 * 获取相应frame的属性值
 * @param element
 */
function getOperationFrameInfo(element: any): IFrameInfo {
    const styleInfo = element.props.style;
    const currentFrame = element.operationFrame;
    const isGroupChildrenConnector = !!(element.parent
        && element.parent.type === UIModelType.GROUP
        && element.type === UIModelType.CONNECTOR);
    return {
        top: getValueWithDefault2(currentFrame?.top, styleInfo.top, 0),
        left: getValueWithDefault2(currentFrame?.left, styleInfo.left, 0),
        width: getValueWithDefault2(currentFrame?.width, styleInfo.width, 0),
        height: getValueWithDefault2(currentFrame?.height, styleInfo.height, 0),
        flipH: getValueWithDefault2(currentFrame?.flipH, styleInfo.flipH, 0),
        flipV: getValueWithDefault2(currentFrame?.flipV, styleInfo.flipV, 0),
        rotate: isGroupChildrenConnector && element.rotateInGroup
            ? getValueWithDefault2(element.rotateInGroup, styleInfo.rotate, 0)
            : getValueWithDefault2(currentFrame?.rotate, styleInfo.rotate, 0),
    };
}

function useOperation(element: any, tableResizing: boolean, fromScale?: number) {
    return !(tableResizing || !element.operationFrame || (fromScale === 1));
}

/**
 * 根据条件，获取响应的frame rect
 * @param options
 */
export function getElementRect(options: any): IFrameInfo {
    const { element, tableResizing, fromScale } = options;
    const useOperationFrame = useOperation(element, tableResizing, fromScale);
    if (useOperationFrame) {
        return getOperationFrameInfo(element);
    }
    const styleInfo = element.props.style;
    const isGroupChildrenConnector = !!(element.parent
        && element.parent.type === UIModelType.GROUP
        && element.type === UIModelType.CONNECTOR);
    return {
        top: getValueWithDefault1(styleInfo.top, 0),
        left: getValueWithDefault1(styleInfo.left, 0),
        width: getValueWithDefault1(styleInfo.width, 0),
        height: getValueWithDefault1(styleInfo.height, 0),
        flipH: getValueWithDefault1(styleInfo.flipH, 0),
        flipV: getValueWithDefault1(styleInfo.flipV, 0),
        rotate: isGroupChildrenConnector && element.rotateInGroup
            ? getValueWithDefault1(element.rotateInGroup, 0)
            : getValueWithDefault1(styleInfo.rotate, 0),
    };
}

export function checkIsSelectable(element) {
    let selectable = element.selectable
        && element.currentEditState <= PPTEditorStateType.SELECTABLE;
    if (element.isPlaceholder
        && !element.isCustomPlaceholder
        && element.currentEditState > PPTEditorStateType.EDITABLE) {
        selectable = false;
    }
    return selectable;
}
